<template>
<nav id="site-navigation" class="has-branding main-navigation nav-align-right sub-menu-right" aria-label="Primary" itemtype="https://schema.org/SiteNavigationElement" itemscope>
  <div class="inside-navigation">

    <!-- Logo 区域 -->
    <div class="navigation-branding">
      <div class="site-logo">
        <a href="https://gbwhetsapp.com/" title="GBWhatsApp" rel="home">
          <img class="header-image is-logo-image" alt="GBWhatsApp" src="../assets/logo.webp" title="GBWhatsApp">
        </a>
      </div>
      <p class="main-title" itemprop="headline">
        <a href="https://gbwhetsapp.com/" rel="home">GB Whets App</a>
      </p>
    </div>

    <!-- ========== 移动端菜单 ========== -->
    <ul id="menu-primary-menu-mobile" class="menu sf-menu mobile-menu-page" v-show="isMenuClicked">
      <li class="menu-item">
        <router-link :to="homePath" @click.native="isMenuClicked = false">Home</router-link>
      </li>
      <li
        v-for="item in navMenuItems.filter((i) => i.labelKey !== 'home')"
        :key="item.labelKey"
        class="menu-item"
        :class="{ 'has-mobile-dropdown': !!item.dropdown }"
      >
        <template v-if="item.dropdown">
          <div class="mobile-dropdown-header" @click="toggleDropdown(item.labelKey)">
            <span>{{ t(item.labelKey) }}</span>
            <svg class="dropdown-arrow" :class="{ rotated: openDropdown === item.labelKey }" viewBox="0 0 24 24" width="16" height="16">
              <path fill="currentColor" d="M7 10l5 5 5-5z"/>
            </svg>
          </div>
          <ul class="mobile-sub-menu" v-show="openDropdown === item.labelKey">
            <li v-for="sub in item.dropdown" :key="sub.path">
              <router-link :to="sub.path" :class="{ 'sub-active': isActive(sub.path) }" @click.native="isMenuClicked = false">
                {{ sub.label }}
              </router-link>
            </li>
          </ul>
        </template>
        <router-link v-else :to="item.path" :class="{ active: isNavItemActive(item) }" @click.native="isMenuClicked = false">
          {{ t(item.labelKey) }}
        </router-link>
      </li>

      <!-- 移动端：主题切换 -->
      <!-- <li class="menu-item">
        <div class="mobile-dropdown-header" @click="isThemeOpen = !isThemeOpen">
          <span>
            <svg viewBox="0 0 24 24" width="16" height="16" style="margin-right:6px;vertical-align:middle"><path fill="currentColor" d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.04 10 9c0 3.31-2.69 6-6 6h-1.77c-.28 0-.5.22-.5.5 0 .12.05.23.13.33.41.47.64 1.06.64 1.67A2.5 2.5 0 0 1 12 22zm0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8c.28 0 .5-.22.5-.5a.54.54 0 0 0-.14-.35c-.41-.46-.63-1.05-.63-1.65a2.5 2.5 0 0 1 2.5-2.5H16c2.21 0 4-1.79 4-4 0-3.86-3.59-7-8-7z"/></svg>
            Theme
          </span>
          <svg class="dropdown-arrow" :class="{ rotated: isThemeOpen }" viewBox="0 0 24 24" width="16" height="16">
            <path fill="currentColor" d="M7 10l5 5 5-5z"/>
          </svg>
        </div>
        <ul class="mobile-sub-menu" v-show="isThemeOpen">
          <li v-for="theme in themes" :key="theme.id">
            <a
              href="javascript:void(0)"
              :class="{ 'sub-active': currentThemeId === theme.id }"
              @click="switchTheme(theme.id)"
            >
              <span class="theme-dot" :style="{ background: theme.colors.primary }"></span>
              {{ theme.icon }} {{ theme.nameCn }}
            </a>
          </li>
        </ul>
      </li> -->
    </ul>

    <!-- ========== 桌面端导航 ========== -->
    <div id="primary-menu" class="main-nav">
      <div class="mobile-menu" v-if="isCompactNav">
        <div class="menu-toggle" @click="isMenuClicked = !isMenuClicked">
          <img src="@/assets/menu.svg" alt="menu button" v-if="!isMenuClicked">
          <img src="@/assets/xmark-black.svg" alt="close button" v-else>
        </div>
      </div>
      <ul v-else id="menu-primary-menu" class="menu sf-menu">
        <li
          v-for="item in navMenuItems"
          :key="item.labelKey"
          class="menu-item"
          :class="{
            'has-dropdown': !!item.dropdown,
            'is-active': isNavItemActive(item) || isDropdownActive(item),
          }"
          @mouseenter="item.dropdown && (openDropdown = item.labelKey)"
          @mouseleave="item.dropdown && (openDropdown = null)"
        >
          <template v-if="item.dropdown">
            <a href="javascript:void(0)" class="dropdown-trigger" :class="{ active: openDropdown === item.labelKey }">
              {{ t(item.labelKey) }}
              <svg class="dropdown-arrow" :class="{ rotated: openDropdown === item.labelKey }" viewBox="0 0 24 24" width="14" height="14">
                <path fill="currentColor" d="M7 10l5 5 5-5z"/>
              </svg>
            </a>
            <div class="dropdown-bridge" aria-hidden="true"></div>
            <ul class="sub-menu" :class="{ visible: openDropdown === item.labelKey }">
              <li v-for="sub in item.dropdown" :key="sub.path">
                <router-link :to="sub.path" :class="{ 'sub-active': isActive(sub.path) }" @click.native="closeDropdown">
                  {{ sub.label }}
                </router-link>
              </li>
            </ul>
          </template>
          <router-link v-else :to="item.path" :class="{ active: isNavItemActive(item) }">
            {{ t(item.labelKey) }}
          </router-link>
        </li>

        <!-- 桌面端：主题切换下拉 -->
        <!-- <li class="menu-item has-dropdown theme-switcher-item" @mouseenter="isThemeOpen = true" @mouseleave="isThemeOpen = false">
          <a href="javascript:void(0)" class="dropdown-trigger theme-trigger" :class="{ active: isThemeOpen }">
            <span class="theme-dot-indicator" :style="{ background: currentThemeColor }"></span>
            Theme
            <svg class="dropdown-arrow" :class="{ rotated: isThemeOpen }" viewBox="0 0 24 24" width="14" height="14">
              <path fill="currentColor" d="M7 10l5 5 5-5z"/>
            </svg>
          </a>
          <div class="dropdown-bridge" aria-hidden="true"></div>
          <ul class="sub-menu theme-dropdown" :class="{ visible: isThemeOpen }">
            <li v-for="theme in themes" :key="theme.id">
              <a
                href="javascript:void(0)"
                :class="{ 'sub-active': currentThemeId === theme.id }"
                @click="switchTheme(theme.id)"
              >
                <span class="theme-dot" :style="{ background: theme.colors.primary }"></span>
                <span class="theme-name">{{ theme.icon }} {{ theme.nameCn }}</span>
                <span class="theme-desc">{{ theme.description }}</span>
              </a>
            </li>
          </ul>
        </li> -->
      </ul>
    </div>

  </div>
</nav>
</template>

<script>
import Search from './Search.vue';
import { themes, setTheme, getCurrentThemeId } from '../data/themeEngine.js';

export default {
  name: 'HeadNav',
  props: {
    selectedLanguage: { type: String, required: true },
    page: { type: String, required: true },
    gotodownload: { type: Function },
    apk: { type: [Object, String] },
  },
  components: { Search },
  data() {
    return {
      isMenuClicked: false,
      isSearchClicked: false,
      isLangOpen: false,
      openDropdown: null,
      isThemeOpen: false,
      viewportWidth: typeof window !== 'undefined' ? window.innerWidth : 1280,
      themes,
      currentThemeId: 'emerald',
      lang: [
        { lang: 'en', val: '🇺🇸 English' },
        { lang: 'id', val: '🇮🇩 Bahasa Indonesia' },
        { lang: 'pt', val: '🇵🇹 Português' },
        { lang: 'es', val: '🇪🇸 Español' },
        { lang: 'hi', val: '🇮🇳 हिंदी' },
      ],
      translation: {
        en: {
          home: 'Home',
          download: 'Download',
          blogs: 'Blogs',
          guides: 'Guides',
          banSafety: 'Ban & Safety',
          errors: 'Errors',
          features: 'Features',
          useCases: 'Use Cases',
          insights: 'Insights',
          waMods: 'WA Mods',
        },
        ar: {
          home: 'الصفحة الرئيسية',
          download: 'تحميل',
          blogs: 'المدونات',
        },
        id: {
          home: 'Beranda',
          download: 'Unduh',
          blogs: 'Blog',
        },
        pt: {
          home: 'Casa',
          download: 'Baixar',
          blogs: 'Blogs',
        },
        es: {
          home: 'Casa',
          download: 'Descargar',
          blogs: 'Blogs',
        },
        hi: {
          home: 'घर',
          download: 'डाउनलोड',
          blogs: 'ब्लॉग',
        },
      },
      navMenuItems: [
        { labelKey: 'home', path: '/' },
        {
          labelKey: 'download',
          path: '/download/',
          activePaths: [
            '/download/',
            '/how-to-install-gb-whatsapp/',
            '/how-to-update-gb-whatsapp/',
            '/how-to-backup-and-restore-gb-whatsapp/',
          ],
        },
        {
          labelKey: 'features',
          path: '/features/',
          dropdown: [
            { path: '/features/', label: 'Features Hub' },
            { path: '/message-scheduler/', label: 'Message Scheduler' },
            { path: '/auto-reply/', label: 'Auto Reply' },
            { path: '/hide-blue-ticks/', label: 'Hide Blue Ticks' },
            { path: '/dnd-mode/', label: 'DND Mode' },
            { path: '/custom-themes/', label: 'Custom Themes' },
          ],
        },
        {
          labelKey: 'useCases',
          path: '/gb-whatsapp-for-small-business/',
          dropdown: [
            { path: '/gb-whatsapp-for-small-business/', label: 'Small Business Guide' },
            { path: '/gb-whatsapp-for-marketing/', label: 'Marketing Guide' },
            { path: '/gb-whatsapp-for-students/', label: 'Students Guide' },
            { path: '/bulk-messaging-guide/', label: 'Bulk Messaging Guide' },
            { path: '/privacy-setup-guide/', label: 'Privacy Setup Guide' },
          ],
        },
        {
          labelKey: 'banSafety',
          path: '/ban-fix/',
          dropdown: [
            { path: '/ban-fix/', label: 'Ban Fix' },
            { path: '/temporary-ban-solution/', label: 'Temporary Ban Solution' },
            { path: '/how-to-avoid-ban/', label: 'Ban Prevention Guide' },
            { path: '/is-gb-whatsapp-safe/', label: 'Is GB WhatsApp Safe?' },
            { path: '/ban-risk-analysis/', label: 'Ban Risk Analysis' },
          ],
        },
        {
          labelKey: 'errors',
          path: '/app-not-installed-error/',
          dropdown: [
            { path: '/app-not-installed-error/', label: 'App Not Installed' },
            { path: '/restore-failed-error/', label: 'Restore Failed' },
            { path: '/verification-problem/', label: 'Verification Problem' },
          ],
        },
        {
          labelKey: 'insights',
          path: '/ban-risk-analysis/',
          dropdown: [
            { path: '/ban-risk-analysis/', label: 'Ban Risk Analysis' },
            { path: '/gb-vs-whatsapp-comparison/', label: 'GB vs WhatsApp Comparison' },
          ],
        },
        {
          labelKey: 'waMods',
          path: '/wa-mods/',
          dropdown: [
            { path: '/wa-mods/', label: 'WA Mods Hub' },
            { path: '/fmwhatsapp/', label: 'FMWhatsApp' },
            { path: '/yowhatsapp/', label: 'YoWhatsApp' },
            { path: '/whatsapp-plus/', label: 'WhatsApp Plus' },
            { path: '/ogwhatsapp/', label: 'OGWhatsApp' },
          ],
        },
      ],
    };
  },
  computed: {
    homePath() {
      const paths = { en: '/', hi: '/in/', es: '/es/', pt: '/pt/', id: '/id/' };
      return paths[this.selectedLanguage] || '/';
    },
    currentLangFlag() {
      const flags = { en: '🇺🇸', hi: '🇮🇳', es: '🇪🇸', pt: '🇵🇹', id: '🇮🇩' };
      return flags[this.selectedLanguage] || '🇺🇸';
    },
    currentLangName() {
      const names = { en: 'English', hi: 'हिंदी', es: 'Español', pt: 'Português', id: 'Indonesia' };
      return names[this.selectedLanguage] || 'English';
    },
    currentPath() {
      return this.$route?.path || '';
    },
    currentThemeColor() {
      const t = this.themes.find((t) => t.id === this.currentThemeId);
      return t ? t.colors.primary : '#10B981';
    },
    isCompactNav() {
      return this.$ua.isMobileDevice || this.viewportWidth <= 1180;
    },
  },
  watch: {
    isSearchClicked(newVal) {
      if (!newVal) {
        this.$refs.searchComponent?.resetSearch();
      }
    },
  },
  mounted() {
    this.currentThemeId = getCurrentThemeId();
    this.updateViewportWidth();
    document.addEventListener('click', this.handleOutsideClick);
    window.addEventListener('resize', this.updateViewportWidth);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
    window.removeEventListener('resize', this.updateViewportWidth);
  },
  methods: {
    updateViewportWidth() {
      this.viewportWidth = window.innerWidth || document.documentElement.clientWidth || 1280;
      if (!this.isCompactNav) {
        this.isMenuClicked = false;
      }
    },
    t(key) {
      return this.translation[this.selectedLanguage]?.[key] || this.translation.en?.[key] || key;
    },
    isActive(path) {
      if (!path) return false;
      return this.currentPath === path || this.currentPath.startsWith(`${path}#`);
    },
    isNavItemActive(item) {
      if (item.activePaths && item.activePaths.length) {
        return item.activePaths.some((p) => this.isActive(p));
      }
      return this.isActive(item.path);
    },
    isDropdownActive(item) {
      if (!item.dropdown) return false;
      return item.dropdown.some((sub) => this.isActive(sub.path));
    },
    toggleDropdown(labelKey) {
      this.openDropdown = this.openDropdown === labelKey ? null : labelKey;
    },
    closeDropdown() {
      this.openDropdown = null;
    },
    handleOutsideClick(e) {
      const nav = document.getElementById('site-navigation');
      if (nav && !nav.contains(e.target)) {
        this.closeDropdown();
        this.isThemeOpen = false;
      }
    },
    switchLanguage(lang) {
      this.isLangOpen = false;
      const routes = { en: '/', hi: '/in/', es: '/es/', pt: '/pt/', id: '/id/' };
      window.location.href = routes[lang] || '/';
    },
    switchTheme(themeId) {
      this.currentThemeId = themeId;
      this.isThemeOpen = false;
      setTheme(themeId);
    },
    download() {
      if (typeof this.gotodownload === 'function') {
        this.gotodownload();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&family=Outfit:wght@400;500;600;700&display=swap');

// 主题变量（通过 themeEngine.js 注入到 :root）
// 降级默认值：使用深海蓝
$brand:        var(--theme-primary, #1E3A5F);
$brand-mid:    var(--theme-primary-dark, #0F2347);
$brand-soft:   var(--theme-primary-light, #3B82C4);
$brand-pale:   var(--theme-primary-pale, #EBF2FC);
$text-main:    var(--theme-text-main, #0F2347);
$text-muted:   var(--theme-text-muted, #64748b);
$border:       var(--theme-card-border, rgba(30,58,95,0.1));
$nav-bg:       var(--theme-nav-bg, rgba(255,255,255,0.97));
$nav-hover:    var(--theme-nav-hover, #1E3A5F);
$card-shadow:  var(--theme-card-shadow, 0 4px 20px rgba(30,58,95,0.08));
$gradient:     var(--theme-gradient, linear-gradient(135deg, #0F2347 0%, #1E3A5F 100%));

#site-navigation {
  position: sticky;
  top: 0;
  z-index: 10000;
  background: $nav-bg;
  backdrop-filter: blur(20px);
  border-bottom: 1px solid $border;
  box-shadow: 0 1px 0 rgba(30,58,95,0.06), 0 4px 18px rgba(30,58,95,0.05);

  .inside-navigation {
    width: 1160px;
    max-width: 100%;
    margin: 0 auto;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 12px;
    padding: 0 16px;
    min-height: 60px;
  }
}

.navigation-branding {
  display: flex;
  align-items: center;
  gap: 11px;
  flex-shrink: 0;
  min-width: 0;

  .site-logo {
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
  }

  .site-logo img {
    display: block;
    height: 40px;
    width: 40px;
    max-width: 40px;
    object-fit: contain;
    border-radius: 10px;
    transition: transform 0.28s ease, box-shadow 0.28s ease;
    box-shadow: 0 2px 8px rgba(30,58,95,0.12);

    &:hover {
      transform: scale(1.06);
      box-shadow: 0 4px 14px rgba(30,58,95,0.2);
    }
  }

  .main-title {
    font-family: 'Outfit', sans-serif;
    font-size: 20px;
    font-weight: 700;
    margin: 0;
    white-space: nowrap;

    a {
      text-decoration: none;
      background: $gradient;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      letter-spacing: -0.3px;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }
}

.main-nav {
  flex: 1 1 auto;
  min-width: 0;

  .menu {
    list-style: none !important;
    margin: 0 !important;
    padding: 0;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: flex-end;
    gap: 4px;
  }
}

.menu-item {
  position: relative;
  display: flex;
  align-items: center;

  &.has-dropdown {
    position: relative;
  }

  > a:not(.dropdown-trigger) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 38px;
    padding: 0 11px;
    font-family: 'DM Sans', sans-serif;
    font-weight: 500;
    font-size: 13.5px;
    color: $text-main;
    text-decoration: none;
    border-radius: 0;
    border: none;
    background: transparent;
    transition: color 0.18s ease;
    white-space: nowrap;

    &:hover {
      color: $nav-hover;
    }

    &.active {
      color: $nav-hover;
      font-weight: 600;
    }
  }
}

.dropdown-trigger {
  display: inline-flex !important;
  align-items: center;
  gap: 4px;
  height: 38px;
  padding: 0 11px !important;
  font-family: 'DM Sans', sans-serif !important;
  font-weight: 500;
  font-size: 13.5px;
  color: $text-main !important;
  text-decoration: none;
  border-radius: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: color 0.18s ease;
  white-space: nowrap;
  position: relative;
  z-index: 2;

  &:hover,
  &.active {
    color: $nav-hover !important;
  }
}

.dropdown-bridge {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  width: auto;
  height: 18px;
  margin-left: 0;
  pointer-events: none;
  z-index: 1;
}

.dropdown-arrow {
  transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
  flex-shrink: 0;
  color: inherit;

  &.rotated {
    transform: rotate(180deg);
  }
}

#site-navigation .main-nav .sub-menu li a {
  height: auto !important;
  line-height: 1.35 !important;
  padding: 8px 12px !important;
}

.sub-menu {
  position: absolute;
  top: calc(100% + 12px);
  left: auto;
  right: 0;
  background: #fff;
  border-radius: 16px;
  box-shadow: $card-shadow;
  border: 1px solid $border;
  min-width: 228px;
  max-height: min(70vh, 420px);
  overflow-y: auto;
  z-index: 10001;
  list-style: none;
  margin: 0;
  padding: 6px;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateY(-8px);
  transition: opacity 0.2s ease, transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1), visibility 0.2s ease;

  &.visible {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    transform: translateY(0);
  }

  li {
    margin: 0;
    padding: 0;
    line-height: normal;

    a {
      display: flex;
      align-items: center;
      gap: 10px;
      height: auto;
      padding: 8px 12px;
      line-height: 1.35;
      color: $text-main;
      text-decoration: none;
      font-family: 'DM Sans', sans-serif;
      font-size: 13.5px;
      font-weight: 500;
      border-radius: 10px;
      transition: background 0.15s ease, color 0.15s ease;
      white-space: nowrap;
      list-style: none;

      &:hover {
        background: $brand-pale;
        color: $brand;
      }

      &.sub-active {
        background: $brand-pale;
        color: $brand;
        font-weight: 700;
      }
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: -1px;
    left: 16px;
    width: 34px;
    height: 3px;
    background: $gradient;
    border-radius: 0 0 3px 3px;
  }
}

// 主题切换下拉特殊样式
.theme-dropdown {
  min-width: 240px !important;
  right: 0;
  left: auto;

  li a {
    flex-wrap: wrap;
  }

  .theme-name {
    flex: 1;
    font-weight: 600;
    font-size: 13.5px;
  }

  .theme-desc {
    width: 100%;
    font-size: 11px;
    color: $text-muted;
    padding-left: 26px;
    font-weight: 400 !important;
  }
}

.theme-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
  box-shadow: 0 0 0 2px rgba(0,0,0,0.08);
}

.theme-dot-indicator {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  transition: background 0.3s ease;
  box-shadow: 0 0 0 2px rgba(0,0,0,0.1);
}

.theme-trigger {
  gap: 6px !important;
}

.mobile-dropdown-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: $text-main;
  border-radius: 10px;
  background: transparent;
  border: none;
  user-select: none;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: $brand-pale;
    color: $brand;
  }

  .dropdown-arrow {
    flex-shrink: 0;
    margin-left: 8px;
    transition: transform 0.2s ease;
    color: $text-muted;
    &.rotated { transform: rotate(180deg); }
  }
}

.mobile-sub-menu {
  list-style: none;
  margin: 0;
  padding: 2px 0 6px 0;
  width: 100%;
  box-sizing: border-box;

  li {
    width: 100%;
    margin: 0;
  }

  li a {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px 10px 18px;
    color: $text-main;
    text-decoration: none;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    border-radius: 8px;
    border-left: 2px solid rgba(30, 58, 95, 0.12);
    margin-left: 2px;
    transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;

    &:hover {
      background: $brand-pale;
      color: $brand;
      border-left-color: rgba(30, 58, 95, 0.28);
    }

    &.sub-active {
      background: $brand-pale;
      color: $brand;
      font-weight: 700;
      border-left-color: $brand;
    }
  }
}

.mobile-menu .menu-toggle {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 11px;
  transition: background 0.18s ease;

  &:hover { background: $brand-pale; }

  img { width: 22px; height: 22px; }
}

.lang-switcher-mobile .lang-current {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  font-size: 15px;
  color: $text-main;
  border-radius: 10px;

  &:hover { background: $brand-pale; }
}

@media (max-width: 1100px) {
  .main-nav .menu {
    gap: 2px;
  }

  .menu-item > a:not(.dropdown-trigger),
  .dropdown-trigger {
    padding-left: 10px !important;
    padding-right: 10px !important;
    font-size: 13px;
  }
}

@media (max-width: 1180px) {
  #site-navigation .inside-navigation {
    padding: 0 12px;
    min-height: 58px;
  }

  .navigation-branding {
    flex: 1 1 auto;
    max-width: calc(100% - 58px);
  }

  .navigation-branding .site-logo {
    width: 34px;
    height: 34px;
    flex-basis: 34px;
  }

  .navigation-branding .site-logo img {
    width: 34px;
    height: 34px;
    max-width: 34px;
  }

  .navigation-branding .main-title {
    min-width: 0;
    overflow: hidden;
    font-size: 17px;
    text-overflow: ellipsis;
  }

  .inside-navigation .mobile-menu-page {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 1001;
    margin: 0 !important;
    padding: 8px 12px 14px;
    background: $nav-bg;
    backdrop-filter: blur(12px);
    border-bottom: 1px solid $border;
    box-shadow: 0 12px 32px rgba(30,58,95,0.1);

    .menu-item {
      width: 100%;
      max-width: 100%;
      padding: 0;
      margin-bottom: 2px;
      box-sizing: border-box;

      > a {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
        font-size: 15px;
        font-weight: 600;
        text-align: left;
        color: $text-main;
        display: block;
        padding: 12px 14px;
        border-radius: 10px;
        height: auto;
        justify-content: flex-start;
        transition: background 0.15s ease, color 0.15s ease;

        &:hover {
          background: $brand-pale;
          color: $brand;
        }

        &.active {
          background: $brand-pale;
          color: $brand;
        }
      }

      &.has-mobile-dropdown {
        display: block;
        width: 100%;

        .mobile-dropdown-header {
          width: 100%;
        }

        .mobile-sub-menu {
          padding-left: 0;
        }
      }
    }
  }

  .main-nav {
    flex: 0 0 auto;
    display: flex;
    justify-content: flex-end;

    .mobile-menu {
      display: flex;
      justify-content: flex-end;
    }
  }

  .theme-dropdown {
    position: static !important;
    opacity: 1 !important;
    pointer-events: auto !important;
    transform: none !important;
    box-shadow: none !important;
    border: none !important;
    background: transparent !important;
    border-radius: 8px !important;
    min-width: unset !important;
    padding: 4px 0 0 0 !important;

    li a {
      padding: 8px 12px;
      background: transparent !important;
      &:hover { background: $brand-pale !important; }
    }
  }

  .theme-switcher-item {
    .dropdown-bridge,
    .theme-dropdown {
      display: none;
    }
  }
}

@media (max-width: 420px) {
  .navigation-branding {
    gap: 8px;
  }

  .navigation-branding .main-title {
    font-size: 16px;
  }
}
</style>
